import * as React from "react";
function SvgI(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M18.79 27.31A15.8 15.8 0 0117.35 29a14.56 14.56 0 01-1.77 1.52 10.75 10.75 0 01-1.85 1.1 3.93 3.93 0 01-1.58.42q-.87 0-1.09-.55a3.37 3.37 0 01-.22-1.25 2.27 2.27 0 010-.4c0-.1 0-.22.08-.35l3-14.73a.66.66 0 00.05-.3c0-.27-.11-.4-.33-.4q-.6 0-2.55 2L10.53 15A12.89 12.89 0 0112 13.35a18 18 0 011.79-1.5 12.15 12.15 0 011.85-1.12 3.82 3.82 0 011.63-.45 1.05 1.05 0 01.9.4 2.55 2.55 0 01.3 1.45v.35a2 2 0 01-.05.4l-2.89 12.48c-.07.37-.14.72-.22 1.07a4.77 4.77 0 00-.11 1q0 .85.43.85.6 0 2.55-2zm-.2-21.62Q16 5.69 16 2.8A2.48 2.48 0 0118.8 0q2.66 0 2.66 2.8a2.55 2.55 0 01-2.87 2.89z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgI);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
